class Const {
  // 画面に表示するシステムのバージョン。ここを変えれば表示箇所すべてに反映される。
  static Version = "2.0.0";
  static IseyaTel = "0974-22-6650";
  static IseyaManager = "船串";
  static IseyaZip = "879-7111";
  static IseyaAddress = "大分県豊後大野市三重町赤嶺1161-2";
  static IseyaFax = "0974-22-1500";
}

export default Const;
